<template>
  <div class="share-center-container">
    <el-button 
          icon="el-icon-back" 
          type="text" 
          @click="goBack"
          class="back-btn"
        >
          返回上一页
    </el-button>
    <!-- 页面标题 -->
    <div class="page-title">
      <h2>文件共享中心</h2>
      <p>查看和下载他人共享文件</p>
    </div>

    <!-- 搜索区域 -->
    <div class="search-container card">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input 
            v-model="searchText" 
            placeholder="搜索文件名" 
            prefix-icon="el-icon-search"
            clearable
            @clear="fetchSharedFiles"
            @keyup.enter.native="fetchSharedFiles"
          ></el-input>
        </el-col>
        <!-- <el-col :span="12">
          <el-input 
            v-model="sharerSearch" 
            placeholder="搜索共享者" 
            prefix-icon="el-icon-user"
            @keyup.enter.native="fetchSharedFiles"
          ></el-input>
        </el-col> -->
      </el-row>
    </div>

    <!-- 文件列表区域 -->
    <div class="file-list-container card">
      <el-table 
        :data="fileList" 
        stripe 
        v-loading="loading"
        :row-style="{ height: '50px' }"
        :header-cell-style="headerCellStyle"
        empty-text="暂无共享文件"
      >
        <el-table-column prop="fileName" label="文件名称" min-width="240"><template slot-scope="scope"><file-identity :name="scope.row.fileName" /></template></el-table-column>
        <el-table-column label="文件大小" width="120">
          <template slot-scope="scope">
            {{ formatSize(scope.row.fileSize) }}
          </template>
        </el-table-column>
        <el-table-column prop="shareUserName" label="共享者" width="120"></el-table-column>
        <el-table-column label="共享结束时间" width="180">
          <template slot-scope="scope">
            <span :class="getExpireClass(scope.row.sharedEndDate)">
              {{ formatShareEndTime(scope.row.sharedEndDate) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <!-- 使用带进度条的下载组件 -->
            <file-download-with-progress
              :file-id="scope.row.fileId"
              :file-name="scope.row.fileName"
              :file-size="scope.row.fileSize"
            ></file-download-with-progress>
          </template>
        </el-table-column>
        <div slot="empty" class="workspace-empty"><span class="empty-icon"><i class="el-icon-connection"></i></span><h3>暂时没有共享内容</h3><p>试试其他关键词，或稍后回来看看。</p></div>
      </el-table>

      <!-- 分页控件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getShareFileList } from '@/api/shareCenter';
import FileDownloadWithProgress from '@/components/FileDownloadWithProgress';
import FileIdentity from '@/components/FileIdentity';

export default {
  name: 'ShareCenter',
  components: {
    FileIdentity,
    FileDownloadWithProgress // 注册下载进度条组件
  },
  data() {
    return {
      fileList: [],
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchText: '',
      sharerSearch: ''
    };
  },
  created() {
    this.fetchSharedFiles();
  },
  methods: {
    goBack() {
      window.history.back();
    },

    fetchSharedFiles() {
      this.loading = true;
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        searchFileName: this.searchText,
        // sharer: this.sharerSearch
      };

      getShareFileList(params).then(res => {
        this.fileList = res.data.records || [];
        this.pagination.total = res.data.total || 0;
      }).catch(err => {
        this.$message.error('获取共享文件失败: ' + (err.message || err));
      }).finally(() => {
        this.loading = false;
      });
    },

    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNum = 1;
      this.fetchSharedFiles();
    },

    handleCurrentChange(pageNum) {
      this.pagination.pageNum = pageNum;
      this.fetchSharedFiles();
    },

    formatSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    formatShareEndTime(endTime) {
      if (!endTime) return '永久共享';
      
      const now = new Date();
      const end = new Date(endTime);
      const days = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      
      if (days < 0) return '已过期';
      if (days === 0) return '今天到期';
      if (days === 1) return '明天到期';
      if (days < 7) return `${days}天后到期`;
      
      return end.toLocaleDateString('zh-CN');
    },

    getExpireClass(endTime) {
      if (!endTime) return '';
      
      const now = new Date();
      const end = new Date(endTime);
      const days = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      
      if (days < 0) return 'text-red-600';
      if (days <= 3) return 'text-orange-600';
      return '';
    },

  },
  computed: {
    headerCellStyle() {
      return {
        'background-color': '#f5f7fa',
        'font-weight': '500',
        'color': '#303133'
      };
    }
  }
};
</script>

<style scoped>
.share-center-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-title {
  margin-bottom: 20px;
  color: #303133;
}

.page-title p {
  color: #909399;
  margin-top: 5px;
}

.search-container {
  margin-bottom: 20px;
  padding: 20px;
}

.file-list-container {
  padding: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.text-red-600 {
  color: #f56c6c;
}

.text-orange-600 {
  color: #e6a23c;
}

::v-deep .el-table {
  border-radius: 8px;
  overflow: hidden;
}

::v-deep .el-table tr:hover > td {
  background-color: #f9fafc !important;
}

@media (max-width: 768px) {
  .share-center-container {
    padding: 10px;
  }
  
  .search-container, .file-list-container {
    padding: 15px;
  }
  
  .pagination-container {
    text-align: center;
  }
}
</style>
